import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, Input, OnChanges, inject } from '@angular/core';
import { IrisProjectSelectEngine, FilterProjectsBy } from './project-select.engine';
import { PROJECT_SELECT_PROVIDERS } from './project-select.providers';

@Directive({
  selector: 'sk-select[iris-entity=project]',
  providers: PROJECT_SELECT_PROVIDERS,
})
export class IrisProjectSkSelectDirective implements OnChanges {
  private readonly engine = inject(IrisProjectSelectEngine);

  @Input('limitedProjectIds') searchOnlyInProjects: number[];
  @Input() showCostCenter: boolean;
  @Input() excludeProjectIds: number[];
  @Input() hideRecentProjects: boolean;
  @Input() filterBy?:  FilterProjectsBy;

  ngOnChanges(changes: SimpleChanges<this>): void {
    if (changes.searchOnlyInProjects) {
      this.engine.searchOnlyInProjects(changes.searchOnlyInProjects.currentValue);
    }

    if (changes.showCostCenter) {
      this.engine.options.showCostCenter = coerceBooleanProperty(this.showCostCenter);
    }

    if (changes.hideRecentProjects) {
      this.engine.options.hideRecentProjects = coerceBooleanProperty(this.hideRecentProjects);
    }

    if (changes.excludeProjectIds) {
      this.engine.excludeProjects(changes.excludeProjectIds.currentValue);
    }

    if (changes.filterBy) {
      this.engine.searchOnlyInProjectsWith(this.filterBy);
    }
  }
}
